import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getClinicalRequests, addClinicalRequest, editClinicalRequest, deleteClinicalRequest, getClinicalRequestByKey } from "../../redux/actions/clinicalRequestActions";
import CreateClinicalRequest from "./Popups/CreateClinicalRequest";
import ClinicalRequestDetails from "./Popups/ClinicalRequestDetails";
import EditClinicalRequest from "./Popups/EditClinicalRequest";
import RemoveClinicalRequest from "./Popups/RemoveClinicalRequest";

function createData(id, number, createdAt, contractRequest, state, referral, filial) {
    return {id, number, createdAt, contractRequest, state, referral, filial};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", null, null, null, null),
];
const ClinicalRequestList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("clinicalRequestList.tableItem.id")},
        {text: t("clinicalRequestList.tableItem.number")},
        {text: t("clinicalRequestList.tableItem.createdAt")},
        {text: t("clinicalRequestList.tableItem.contractRequest")},
        {text: t("clinicalRequestList.tableItem.state")},
        {text: t("clinicalRequestList.tableItem.referral")},
        {text: t("clinicalRequestList.tableItem.filial")},
        {text: t("clinicalRequestList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addClinicalRequest(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getClinicalRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getClinicalRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editClinicalRequest(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getClinicalRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteClinicalRequest(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.clinicalRequest);
    if (!localData && state.clinicalRequests)
    {
        rows = state.clinicalRequests;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getClinicalRequests(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("clinicalRequestList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("clinicalRequestList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    contractRequest: _.contractRequest?.number,
                    state: _.state?.name,
                    referral: _.referral?.number,
                    filial: _.filial?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateClinicalRequest action={'create'} title={t("clinicalRequestList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ClinicalRequestDetails action={'details'} title={t("clinicalRequestList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditClinicalRequest action={'edit'} title={t("clinicalRequestList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveClinicalRequest action={'remove'} title={t("clinicalRequestList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ClinicalRequestList;
